import styled from "styled-components";

const StyledPageTitle = styled.div`
  display: inline;
  white-space: nowrap;
  text-align: center;
  font-size: 0.8rem;
  text-transform: uppercase;
`;

export default StyledPageTitle;
